import styled from "styled-components";

export const AboutPage = styled.div`
  min-height: 100vh;
`;

export const AboutLayout = styled.main`
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 72px;
  max-width: 960px;
  margin: 0 auto;
  padding: 72px 24px 104px;
  @media (max-width: 768px) {
    display: block;
    max-width: 320px;
    padding: 48px 0px 88px;
  }
`;

export const AboutPortrait = styled.aside`
  position: sticky;
  top: 104px;
  align-self: start;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    position: static;
    margin-bottom: 48px;
  }
`;

export const AboutImageFrame = styled.img`
  width: 210px;
  height: 210px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  filter: grayscale(10%);
  @media (max-width: 768px) {
    width: 176px;
    height: 176px;
  }
`;

export const AboutCopy = styled.article`
  color: var(--text);
  font-family: "Literata", Georgia, serif;
  font-size: 17px;
  line-height: 29px;
  p {
    margin: 0px 0px 22px;
  }
  a {
    color: var(--heading);
    text-underline-offset: 3px;
  }
`;

export const AboutTitle = styled.h1`
  margin: 0px 0px 28px;
  color: var(--heading);
  font-size: 36px;
  line-height: 44px;
  font-weight: normal;
`;

export const AboutCallout = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 18px;
  margin-top: 42px;
  padding-top: 26px;
  border-top: 1px solid var(--line);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
`;

export const AboutCalloutTitle = styled.h2`
  margin: 0;
  color: var(--text);
  font-size: 17px;
  line-height: 29px;
  font-weight: 500;

  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;
